import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const AdCopy = (props: LevelProps) => {
  return <LevelPage {...props} cardSize="small" cards={LEVEL_CARDS.L3.AD_COPY} />
}
